import { Helper } from '../../../common';

import { QualityPercentageEvolutionWidgetDefinition as definition } from './qualityPercentageEvolution.definition';
import { WidgetBase, IWidgetConfiguration } from '../../models';
import { QualityWidgetType } from '../../../models';

export class QualityPercentageEvolutionWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: { options?: any, qualityWidgetType?: QualityWidgetType } = {};
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 12;
    sizeY = 6;
    type = definition.type;

    constructor(configuration: IWidgetConfiguration & { qualityWidgetType: QualityWidgetType }) {
        super();
        this.guid = Helper.getGuid();
        if (configuration) {
            this.configuration = configuration as any;
            this.name = configuration.name !== undefined ? configuration.name : this.name;
            this.sizeX = configuration.sizeX !== undefined ? configuration.sizeX : this.sizeX;
            this.sizeY = configuration.sizeY !== undefined ? configuration.sizeY : this.sizeY;
            this.row = configuration.row !== undefined ? configuration.row : this.row;
            this.col = configuration.col !== undefined ? configuration.col : this.col;
        }
        if (this.configuration) {
            this.configuration.options = {};
        }
    }
}